import { render, staticRenderFns } from "./referrer-follow-up-tab.vue?vue&type=template&id=34a01a74"
import script from "./referrer-follow-up-tab.vue?vue&type=script&lang=js"
export * from "./referrer-follow-up-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports